export const SECURITY_INCIDENT_BANNER_PREFIX = 'security-incident'

export const SECURITY_INCIDENT_AUTHENTICATED_BANNER_ID =
	'2026-04-29-authenticated'

export const SECURITY_INCIDENT_LOGIN_BANNER_ID =
	'2026-04-29-login'

export const SECURITY_INCIDENT_LOGIN_BANNER_STORAGE_KEY = `${SECURITY_INCIDENT_BANNER_PREFIX}-${SECURITY_INCIDENT_LOGIN_BANNER_ID}`

export const SECURITY_INCIDENT_AUTHENTICATED_BANNER_STORAGE_KEY = `${SECURITY_INCIDENT_BANNER_PREFIX}-${SECURITY_INCIDENT_AUTHENTICATED_BANNER_ID}`

export function dismissSecurityIncidentBanners() {
	if (!process.client) {
		return
	}

	localStorage.setItem(SECURITY_INCIDENT_LOGIN_BANNER_STORAGE_KEY, '1')
	localStorage.setItem(
		SECURITY_INCIDENT_AUTHENTICATED_BANNER_STORAGE_KEY,
		'1'
	)
}
